// src/icons/AppIcon.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function AppIcon() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: "0.75",
            y: "0.75",
            width: "5.5",
            height: "5.5",
            rx: "1.25",
            stroke: "currentColor",
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: "0.75",
            y: "9.75",
            width: "5.5",
            height: "5.5",
            rx: "1.25",
            stroke: "currentColor",
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: "9.75",
            y: "0.75",
            width: "5.5",
            height: "5.5",
            rx: "1.25",
            stroke: "currentColor",
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            x: "9.75",
            y: "9.75",
            width: "5.5",
            height: "5.5",
            rx: "1.25",
            stroke: "currentColor",
            strokeWidth: "1.5"
          }
        )
      ]
    }
  );
}

export {
  AppIcon
};
